(() => {
  const aliases = {
    base: 'lower floor bottom kitchen cabinets',
    wall: 'upper overhead hanging kitchen cabinets',
    tall: 'full height pantry utility cabinets',
    'floating-vanities': 'bathroom bath sink washbasin wall mounted wall hung vanity vanities',
    'standard-vanities': 'bathroom bath sink washbasin freestanding floor standing vanity vanities',
    'floating-shelves': 'open shelving wall shelf shelves display',
    panels: 'end side cover decorative cabinet door panel',
    bedroom: 'bed dresser nightstand bedside bedroom furniture',
    'cabinet-lighting': 'led lights lighting strip under cabinet puck illumination',
    'fillers-moulding': 'trim molding moulding filler crown toe kick scribe',
    'kitchen-organizers': 'kitchen pullout organizer storage spice rack pots pans cookware utensils',
    'closet-organizers': 'closet wardrobe clothes clothing shoe shoes belt tie jewelry hanging rack accessories',
    'hinges-drawer-slides': 'hardware hinge hinges slide slides runner runners soft close concealed drawer',
    'bathroom-organizers': 'bath bathroom vanity organizers accessories makeup cosmetics hair dryer towel storage',
    'handles-pulls': 'hardware handle handles pull pulls knob knobs grip cabinet door drawer',
    'waste-recycling': 'trash garbage rubbish waste recycling recycle bin bins pullout kitchen',
    'pantry-storage': 'pantry larder food dry goods kitchen storage pullout shelves',
    'corner-solutions': 'corner cabinet blind corner lazy susan carousel kitchen organizer',
    'drawer-inserts': 'drawer insert divider dividers tray cutlery silverware utensil organizer',
    'under-sink': 'under sink undersink plumbing cleaning supplies caddy storage',
    'laundry-hampers': 'laundry hamper basket dirty clothes washing sorting pullout',
    'power-charging': 'hidden power charging charger electrical electricity outlet socket usb phone docking station',
    'lift-up-hardware': 'lift up door hardware overhead flap lift mechanism stay support',
    'wine-storage': 'wine beverage bottle bottles glass stemware bar drinks rack storage',
    'diy-cabinet-building': 'diy do it yourself build your own cabinets cabinet building assembly assemble hardware hinges hinge drawer slides runners screws connectors fasteners brackets tools wood panels plywood leg levelers levellers leveling feet adjustable legs shelf pins supports pegs'
  };
  const groups = [
    ['vanity','vanities','washbasin'],
    ['knob','knobs','handle','handles','pull','pulls'],
    ['trash','garbage','rubbish','waste'],
    ['charger','charging','charge','power','electrical','outlet','usb'],
    ['organizer','organizers','organiser','organisers','organization'],
    ['molding','moulding','trim'],
    ['slide','slides','runner','runners'],
    ['shelf','shelves','shelving'],
    ['two','2'], ['one','1'], ['bath','bathroom']
  ];
  const normalize = value => value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,' ').trim();
  const words = value => normalize(value).split(/\s+/).filter(Boolean);
  const stop = new Set(['a','an','the','and','or','for','with','of','to','in','my','i','need','want','find','me']);
  const forms = word => [...new Set([word, word.endsWith('s') ? word.slice(0,-1) : word + 's'])];
  function matches(text, query) {
    const haystack = words(text);
    const terms = words(query).filter(w => !stop.has(w));
    return terms.length > 0 && terms.every(term => {
      const group = groups.find(g => g.includes(term)) || [term];
      const alternatives = group.flatMap(forms);
      return haystack.some(w => alternatives.includes(w) || (term.length >= 3 && w.startsWith(term)));
    });
  }
  const departments = {
    cabinets: {name: 'Cabinets', keys: ['base','wall','tall','floating-shelves','bedroom']},
    vanities: {name: 'Vanities', keys: ['floating-vanities','standard-vanities']},
    'organizers-accessories': {name: 'Pullouts, Organizers & Accessories', keys: ['kitchen-organizers','closet-organizers','bathroom-organizers','waste-recycling','pantry-storage','corner-solutions','drawer-inserts','under-sink','laundry-hampers','wine-storage']},
    hardware: {name: 'Hardware', keys: ['handles-pulls','hinges-drawer-slides','lift-up-hardware','cabinet-lighting','power-charging']},
    diy: {name: 'DIY — Building Your Own Cabinets?', keys: ['diy-cabinet-building','panels','fillers-moulding','hinges-drawer-slides']}
  };
  const parentOf = key => Object.keys(departments).find(id => departments[id].keys.includes(key));
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const links = [...root.querySelectorAll('[data-category]')];
    const results = root.querySelector('.gcs-catalog__results');
    const heading = root.querySelector('[data-heading]');
    const status = root.querySelector('[data-status]');
    const products = root.querySelector('[data-products]');
    const cards = [...root.querySelectorAll('[data-product]')];
    const input = root.querySelector('[data-search]');
    const clear = root.querySelector('[data-clear]');
    const searchStatus = root.querySelector('[data-search-status]');
    const departmentLinks = [...root.querySelectorAll('[data-department]')];
    const browseHeading = root.querySelector('[data-browse-heading]');
    const departmentHeading = root.querySelector('[data-department-heading]');
    const categoryGrid = root.querySelector('.gcs-catalog__categories');
    let selected = '';
    let currentDepartment = '';
    function render() {
      const query = input.value.trim();
      clear.hidden = !query;
      departmentLinks.forEach(link => {
        if (!query && link.dataset.department === currentDepartment) link.setAttribute('aria-current','true');
        else link.removeAttribute('aria-current');
      });
      browseHeading.hidden = !query && !currentDepartment;
      categoryGrid.hidden = !query && !currentDepartment;
      departmentHeading.textContent = query ? 'Matching subcategories' : (departments[currentDepartment]?.name || '');
      if (query) {
        links.forEach(link => {
          link.hidden = !matches(link.textContent + ' ' + (aliases[link.dataset.category] || ''), query);
          link.removeAttribute('aria-current');
        });
        cards.forEach(card => card.hidden = !matches(card.dataset.searchText, query));
        const categoryCount = links.filter(l => !l.hidden).length;
        const productCount = cards.filter(c => !c.hidden).length;
        searchStatus.textContent = categoryCount || productCount
          ? categoryCount + ' matching ' + (categoryCount === 1 ? 'category' : 'categories') + ' · ' + productCount + ' matching ' + (productCount === 1 ? 'product' : 'products')
          : 'No matches. Try a broader term such as vanity, handles, storage or DIY.';
        results.hidden = !productCount;
        products.hidden = !productCount;
        heading.hidden = false;
        heading.textContent = 'Matching products';
        status.textContent = '';
        return;
      }
      searchStatus.textContent = '';
      links.forEach(link => {
        link.hidden = !departments[currentDepartment]?.keys.includes(link.dataset.category);
        if (link.dataset.category === selected) link.setAttribute('aria-current','true');
        else link.removeAttribute('aria-current');
      });
      const active = links.find(link => link.dataset.category === selected);
      results.hidden = !active && !currentDepartment;
      heading.hidden = !active;
      products.hidden = !active;
      status.textContent = '';
      if (!active && currentDepartment === 'diy') status.textContent = 'Build your own cabinets with hinges, drawer slides, screws, wood panels, leg levelers and shelf pins.';
      cards.forEach(card => card.hidden = false);
      if (!active) return;
      heading.textContent = active.textContent.trim();
      products.hidden = selected !== 'floating-vanities';
      status.textContent = selected === 'diy-cabinet-building'
        ? 'Build your own cabinets with hinges, drawer slides, screws, wood panels, leg levelers and shelf pins. Products will be added here soon.'
        : products.hidden ? 'No products in this category yet.' : '';
    }
    links.forEach(link => link.addEventListener('click', event => {
      if (!link.getAttribute('href').startsWith('#')) return;
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      selected = link.dataset.category;
      if (!departments[currentDepartment]?.keys.includes(selected)) currentDepartment = parentOf(selected);
      input.value = '';
      history.pushState(null, '', link.getAttribute('href'));
      render();
      results.scrollIntoView({behavior: 'auto', block: 'start'});
    }));
    const navigateDepartment = key => {
      currentDepartment = departments[key] ? key : '';
      selected = '';
      input.value = '';
      history.pushState(null, '', '#' + (currentDepartment || 'browse'));
      render();
    };
    departmentLinks.forEach(link => link.addEventListener('click', event => {
      if (!link.getAttribute('href').startsWith('#')) return;
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      navigateDepartment(link.dataset.department);
    }));
    root.querySelector('[data-browse-all]').addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); navigateDepartment('');
    });
    input.addEventListener('input', render);
    clear.addEventListener('click', () => { input.value = ''; render(); input.focus(); });
    root.querySelector('[data-search-form]').addEventListener('submit', event => { event.preventDefault(); render(); });
    const restore = () => {
      const key = location.hash.slice(1) || root.dataset.initial;
      selected = departments[key] ? '' : key;
      currentDepartment = departments[key] ? key : (parentOf(selected) || '');
      input.value = '';
      render();
    };
    window.addEventListener('popstate', restore);
    window.addEventListener('hashchange', restore);
    restore();
  }
  document.querySelectorAll('[data-gcs-catalog]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gcs-catalog]').forEach(init));
})();
